import React from 'react';

import { AlineMarkdownEditor } from 'src/components/ai/chat/ChatPanel/AlineMarkdownEditor/AlineMarkdownEditor';
import { isBlankText } from 'src/components/ai/chat/ChatPanel/AlineMarkdownEditor/utils/empty-paragraph';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  row: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  sectionLabel: {
    color: theme.appColors.iconsType,
    fontSize: 14,
    fontWeight: 600,
  },
}));

interface TaskInstructionsProps {
  externalDescription: string;
  hideLabel?: boolean;
}

/** What the owner's team wrote for external reviewers. Nothing shows until they write it. */
export const TaskInstructions = React.memo(function TaskInstructions({
  externalDescription,
  hideLabel = false,
}: TaskInstructionsProps) {
  const { classes } = useStyles();
  if (isBlankText(externalDescription)) return null;

  return (
    <div className={classes.row}>
      {!hideLabel && <span className={classes.sectionLabel}>Instructions</span>}
      <AlineMarkdownEditor
        // The editor reads `value` once on mount, so re-key when the instructions change.
        key={externalDescription}
        noBorder
        readOnly
        minHeight={0}
        value={externalDescription}
      />
    </div>
  );
});
